import React from 'react';
import { useAppSelector, useAppDispatch } from '../../../store/hooks';
import { setCurrentStep, setShowSuccessModal } from '../../../store/slices/bookSlice';
import { useAlert } from '../../../components/AlertBanner';

interface Step {
  id: string;
  label: string;
}

const steps: Step[] = [
  { id: 'book-info', label: 'Book Info' },
  { id: 'book-form-factor', label: 'Book Form Factor' },
  { id: 'book-formatting', label: 'Book Formatting' },
  { id: 'book-cover', label: 'Book Cover' },
  { id: 'pricing', label: 'Pricing' }
];

const ActionButtons: React.FC = () => {
  const dispatch = useAppDispatch();
  const { showAlert } = useAlert();
  const currentStep = useAppSelector((state) => state.book.currentStep);

  const currentStepIndex = steps.findIndex(step => step.id === currentStep);
  const isLastStep = currentStepIndex === steps.length - 1;
  const isFirstStep = currentStepIndex === 0;

  const handleSaveToDrafts = () => {
    showAlert('Saved to drafts!', 'success');
  };

  const handleSaveAndContinue = () => {
    if (isLastStep) {
      dispatch(setShowSuccessModal(true));
    } else {
      const nextStep = steps[currentStepIndex + 1];
      dispatch(setCurrentStep(nextStep.id));
    }
  };

  const handlePrevious = () => {
    if (!isFirstStep) {
      const prevStep = steps[currentStepIndex - 1];
      dispatch(setCurrentStep(prevStep.id));
    }
  };

  return (
    <div className="hidden">
      <div className="flex space-x-4">
        {!isFirstStep && (
          <button
            onClick={handlePrevious}
            className="bg-gray-700 text-white px-6 py-3 rounded hover:bg-gray-600 transition-colors font-semibold"
          >
            ← Previous
          </button>
        )}
        <button
          onClick={handleSaveToDrafts}
          className="border border-gray-500 text-gray-300 px-6 py-3 rounded hover:bg-gray-700 transition-colors font-semibold"
        >
          Save
        </button>
      </div>
      
      <button
        onClick={handleSaveAndContinue}
        className="bg-red-500 text-white px-6 py-3 rounded hover:bg-red-600 transition-colors font-semibold"
      >
        {isLastStep ? 'Submit for Review' : 'Continue'}
      </button>
    </div>
  );
};

export default ActionButtons;